// SlicePlugin definition for the ellipse slice (PRD-F1 §TR5, §T22).
//
// Mirrors the rectangle slice: declares the same 7-key capability set
// including 'border-style' and 'rotation'. Diverges from the sticky slice
// by omitting all text-related capabilities (text-content, rich-edit,
// font-size, font-style). isAnchorTarget always returns true per ND1.

import type { SlicePlugin } from '../../core/object-registry.js';
import {
  type CapabilityDescriptor,
  BORDER_STYLE_VIEW,
  BORDER_STYLE_EDIT,
  ANCHOR_TARGET_VIEW,
  RESIZE_EDIT,
  ROTATION_EDIT,
  BG_COLOR_VIEW,
  BG_COLOR_EDIT,
  STACK_PRESENCE_VIEW,
  UPDATABLE_PROPERTIES_EDIT,
} from '../../core/capabilities/capability.interface.js';
import type { EllipseObject } from './ellipse.interface.js';
import { createEllipseDefaults } from './ellipse-defaults.factory.js';
import { createNode, updateNode } from './ellipse.renderer.js';

const ELLIPSE_CAPABILITIES: readonly CapabilityDescriptor[] = [
  { capability: 'border-style', view: BORDER_STYLE_VIEW, edit: BORDER_STYLE_EDIT },
  { capability: 'anchor-target', view: ANCHOR_TARGET_VIEW },
  { capability: 'resize', edit: RESIZE_EDIT },
  { capability: 'rotation', edit: ROTATION_EDIT },
  { capability: 'background-color', view: BG_COLOR_VIEW, edit: BG_COLOR_EDIT },
  { capability: 'stack-presence', view: STACK_PRESENCE_VIEW },
  { capability: 'updatable-properties', edit: UPDATABLE_PROPERTIES_EDIT },
];

export const ellipseSlice: SlicePlugin<EllipseObject> = {
  type: 'ellipse',
  role: 'primary',
  capabilities: ELLIPSE_CAPABILITIES,
  display: {
    iconUrl: 'fa-circle',
    label: 'Ellipse',
  },
  createDefaults: createEllipseDefaults,
  createNode,
  updateNode,
  isAnchorTarget: () => true,
};
